import { SalesCapacityModule } from './sales-capacity/sales-capacity.module';
import { SalesAdvisorModule } from './sales-advisor/sales-advisor.module';
import { DealershipHolidaysModule } from './../dealership-holidays/dealership-holidays.module';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { SalesSettingsModule } from './sales-settings/sales-settings.module';
import { SalesScheduleModule } from './sales-schedule/sales-schedule.module';
import { SalesTransportCapacityModule } from './sales-transport-capacity/sales-transport-capacity.module';
import { SalesScheduleDashboardModule } from './sales-schedule-dashboard/sales-schedule-dashboard.module';
import { VehicleManagementModule } from './vehicle-management/vehicle-management.module';
import { ChecklistSetupModule } from './checklist-setup/checklist-setup.module';
import { ProtectRoute } from '../shared/guards/protect-route.guard';

const routes: Routes = [
    {
        path: '',
        canActivate:[ProtectRoute],
        children: [
            {
                path: '',
                redirectTo: 'scheduledashboard',
                pathMatch: 'full'
            },
            {
                path: 'settings',
                loadChildren: () => SalesSettingsModule
            },
            {
                path: 'manageadvisors',
                loadChildren: () => SalesAdvisorModule
            },
            {
                path: 'managecapacity',
                loadChildren: () => SalesCapacityModule
            },
            {
                path: 'managetransportcapacity',
                loadChildren: () => SalesTransportCapacityModule
            },
            {
                path: 'schedulerotation',
                loadChildren: () => SalesScheduleModule
            },
            {
                path: 'manageholidays',
                loadChildren: () => DealershipHolidaysModule
            },
            {
                path: 'scheduledashboard',
                loadChildren: () => SalesScheduleDashboardModule
            },
            {
                path: 'vehicle',
                loadChildren: () => VehicleManagementModule
            },
            {
                path: 'checklist',
                loadChildren: () => ChecklistSetupModule
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SalesRoutingModule { }